/** Fotos tab — grid 3-col 4:3 aspectRatio, lightbox.
 *  Z prototype/detail.jsx DetailAltB Fotos sekce. */

import { useState } from "react";
import { Ic } from "@/components/ui/icons";
import { Empty } from "@/components/ui/empty";
import { Modal } from "@/components/ui/modal";
import type { DealPhoto } from "@/lib/fetchers";
import { useDisplayablePhotoUrls } from "@/lib/heic";
import { t } from "@/i18n/de";

export function PhotosTab({ photos, loading }: { photos: DealPhoto[]; loading: boolean }) {
  const [lightbox, setLightbox] = useState<DealPhoto | null>(null);
  // HEIC z iPhonu převedené na JPEG – Chrome/Edge ho jinak nevykreslí.
  const displayUrls = useDisplayablePhotoUrls(photos);

  if (loading) {
    return (
      <div style={{ padding: 40, textAlign: "center", color: "var(--text-3)" }}>{t.loading}</div>
    );
  }

  if (photos.length === 0) {
    return <Empty title="Keine Fotos vorhanden." />;
  }

  return (
    <>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gap: 8,
        }}
      >
        {photos.map((p) => (
          <button
            key={p.name}
            type="button"
            onClick={() => setLightbox(p)}
            style={{
              aspectRatio: "4 / 3",
              borderRadius: 10,
              border: "1px solid var(--border)",
              padding: 0,
              overflow: "hidden",
              cursor: "pointer",
              background: "var(--bg-base-2)",
              position: "relative",
            }}
          >
            <img
              src={displayUrls[p.name] || undefined}
              alt=""
              loading="lazy"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                display: "block",
              }}
            />
          </button>
        ))}
      </div>

      <Modal open={!!lightbox} onOpenChange={(o) => !o && setLightbox(null)} width={900}>
        {lightbox && (
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginBottom: 12,
              }}
            >
              <button
                type="button"
                onClick={() => setLightbox(null)}
                className="btn btn-ghost btn-sm"
                style={{ padding: 6 }}
                aria-label="Schließen"
              >
                <Ic.Close size={16} />
              </button>
            </div>
            <img
              src={displayUrls[lightbox.name] || undefined}
              alt=""
              style={{
                width: "100%",
                maxHeight: "75vh",
                objectFit: "contain",
                display: "block",
                background: "var(--bg-base)",
                borderRadius: 8,
              }}
            />
          </div>
        )}
      </Modal>
    </>
  );
}
